import { useSelector } from "react-redux";
import { RootState } from "../../../store/types";
import { UserType } from "../../../shared/constants";
import CompanySettings from "./CompanySettings";

const SerialNoSettings = () => {
    const { loggedInUser } = useSelector((state: RootState) => state.global);

    return (
        <>
            {loggedInUser?.userType === UserType.Company && <CompanySettings />}
        </>
    );
};

export default SerialNoSettings;